import "./Range.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import { Form } from "react-bootstrap";

const Api = process.env.REACT_APP_API;

const RangeReport = () => {
  const [ranges, setRanges] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [vfcs, setVfcs] = useState([]);
  const [tableData, setTableData] = useState([]);

  // Fetch Ranges
  useEffect(() => {
    const config = Authorization();
    axios
      .get(`${Api}/api/ranges`, config)
      .then((response) => setRanges(response.data))
      .catch((error) => console.error("Error fetching ranges:", error));
  }, []);

  const handleRangeChange = async (rangeId) => {
    setSelectedRange(rangeId);

    if (!rangeId) {
      setVfcs([]);
      setTableData([]);
      return;
    }

    try {
      const config = Authorization();

      // Fetch VFCs
      const vfcResponse = await axios.post(
        `${Api}/api/vfcs/vfcs-by-range`,
        { rangeId },
        config
      );

      const vfcList = vfcResponse.data.vfcs || [];
      setVfcs(vfcList);

      let savedData = [];

      try {
        const reportResponse = await axios.get(
          `${Api}/api/report/loan-reports/${rangeId}`,
          config
        );
        savedData = reportResponse.data.reports;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // No existing loan report found for this range
          console.log("No existing loan report found. Initializing new.");
          savedData = [];
        } else {
          console.error("Error fetching loan report:", error);
          return;
        }
      }

      const savedDataMap = savedData.reduce((acc, item) => {
        acc[item.vfcName] = item;
        return acc;
      }, {});

      const mergedTableData = vfcList.map((vfc) => {
        const saved = savedDataMap[vfc.vfcName] || {};
        const hasPrevData =
          saved.deptLoanTotal ||
          saved.deptRecoveredPrev ||
          saved.deptLoanBeneficiaries;

        return {
          vfcId: vfc._id,
          year: new Date().getFullYear(),
          rangeName: vfc.rangeName || "",
          village: vfc.village || "",
          vfcName: vfc.vfcName || "Unknown",

          isReadonly: !!hasPrevData,

          deptLoanTotal: saved.deptLoanTotal || "",
          deptRecoveredPrev: saved.deptRecoveredPrev || "", // ✅ CORRECTED
          deptLoanBeneficiaries: saved.deptLoanBeneficiaries || "",
          deptTotalRecovered: "", // User enters this month's amount
          deptBalance: "",
          deptPercentage: "",

          revLoanTotal: saved.revLoanTotal || "",
          revRecoveredPrev: saved.revRecoveredPrev || "", // ✅ CORRECTED
          revBeneficiaries: saved.revBeneficiaries || "",
          revTotalRecovered: "", // User enters this month's amount
          revBalance: "",
          revPercentage: "",
        };
      });

      setTableData(mergedTableData);
    } catch (error) {
      console.error("Error in fetching VFCs or report data:", error);
      setVfcs([]);
      setTableData([]);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedTableData = [...tableData];
    const row = { ...updatedTableData[index], [field]: value };

    const deptTotal = parseFloat(row.deptLoanTotal) || 0;
    const deptRecoveredPrev = parseFloat(row.deptRecoveredPrev) || 0;
    const deptRecoveredCurrent = parseFloat(row.deptTotalRecovered) || 0;

    const revTotal = parseFloat(row.revLoanTotal) || 0;
    const revRecoveredPrev = parseFloat(row.revRecoveredPrev) || 0;
    const revRecoveredCurrent = parseFloat(row.revTotalRecovered) || 0;

    if (
      ["deptLoanTotal", "deptRecoveredPrev", "deptTotalRecovered"].includes(
        field
      )
    ) {
      const totalRecovered = deptRecoveredPrev + deptRecoveredCurrent;
      row.deptBalance = (deptTotal - totalRecovered).toFixed(2);
      row.deptPercentage =
        deptTotal > 0 ? ((totalRecovered / deptTotal) * 100).toFixed(2) : "";
    }

    if (
      ["revLoanTotal", "revRecoveredPrev", "revTotalRecovered"].includes(field)
    ) {
      const totalRecovered = revRecoveredPrev + revRecoveredCurrent;
      row.revBalance = (revTotal - totalRecovered).toFixed(2);
      row.revPercentage =
        revTotal > 0 ? ((totalRecovered / revTotal) * 100).toFixed(2) : "";
    }

    updatedTableData[index] = row;
    setTableData(updatedTableData);
  };

  const handleSubmit = () => {
    const config = Authorization();
    axios
      .post(
        `${Api}/api/report/loan-reports`,
        {
          rangeId: selectedRange,
          data: tableData,
        },
        config
      )
      .then((response) => alert("Data saved successfully!"))
      .catch((error) => console.error("Error saving data:", error));
  };

  return (
    <div className="range-report">
      <div className="page-header">
        <h3 className="page-title"> Range </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Range Report
            </li>
          </ol>
        </nav>
      </div>

      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <Form>
              <Form.Group>
                <Form.Label>--Select Range--</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedRange}
                  onChange={(e) => handleRangeChange(e.target.value)}
                >
                  <option value="">Select Range</option>
                  {ranges.map((range) => (
                    <option key={range._id} value={range._id}>
                      {range.rangeName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Form>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row icons-list">
            <div className="Table_data table-responsive">
              {vfcs.length > 0 && (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th rowSpan="2">Year</th>
                      <th rowSpan="2">Range Name</th>
                      <th rowSpan="2">No. of TAP Villages</th>
                      <th rowSpan="2">Village</th>
                      <th colSpan="2">Department Loan</th>
                      <th colSpan="2">Revolving Fund</th>
                    </tr>
                    <tr>
                      <th>Loan & Recovery</th>
                      <th>Beneficiaries & Balance</th>
                      <th>Loan & Recovery</th>
                      <th>Beneficiaries & Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index}>
                        <td>{row.year}</td>
                        <td>{row.rangeName}</td>
                        <td>{row.vfcName}</td>
                        <td>{row.village}</td>

                        {/* Department Loan - Loan & Recovery */}
                        <td>
                          <div className="mb-1">
                            <label className="form-label small">
                              Loan disbursed
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptLoanTotal}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptLoanTotal",
                                  e.target.value
                                )
                              }
                              readOnly={row.isReadonly}
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">
                              Recovered (prev month)
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptRecoveredPrev}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptRecoveredPrev",
                                  e.target.value
                                )
                              }
                              readOnly={row.isReadonly}
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">
                              Recovered (this month)
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptTotalRecovered}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptTotalRecovered",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">
                              Recovered (total)
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptTotalRecovered}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptTotalRecovered",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </td>

                        {/* Department Loan - Beneficiaries & Balance */}
                        <td>
                          <div className="mb-1">
                            <label className="form-label small">
                              Beneficiaries
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptLoanBeneficiaries}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptLoanBeneficiaries",
                                  e.target.value
                                )
                              }
                              readOnly={row.isReadonly}
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">Balance</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptBalance}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptBalance",
                                  e.target.value
                                )
                              }
                              readOnly
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">%</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.deptPercentage}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "deptPercentage",
                                  e.target.value
                                )
                              }
                              readOnly
                            />
                          </div>
                        </td>

                        {/* Revolving Fund - Loan & Recovery */}
                        <td>
                          <div className="mb-1">
                            <label className="form-label small">
                              Loan disbursed
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revLoanTotal}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revLoanTotal",
                                  e.target.value
                                )
                              }
                              readOnly={row.isReadonly}
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">
                              Recovered (prev month)
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revRecoveredPrev}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revRecoveredPrev",
                                  e.target.value
                                )
                              }
                              readOnly={row.isReadonly}
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">
                              Recovered (this month)
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revBeneficiaries}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revBeneficiaries",
                                  e.target.value
                                )
                              }
                              readOnly={row.isReadonly}
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">
                              Recovered (total)
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revTotalRecovered}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revTotalRecovered",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </td>

                        {/* Revolving Fund - Beneficiaries & Balance */}
                        <td>
                          <div className="mb-1">
                            <label className="form-label small">
                              Beneficiaries
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revBeneficiaries}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revBeneficiaries",
                                  e.target.value
                                )
                              }
                              readOnly
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">Balance</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revBalance}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revBalance",
                                  e.target.value
                                )
                              }
                              readOnly
                            />
                          </div>
                          <div className="mb-1">
                            <label className="form-label small">%</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={row.revPercentage}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "revPercentage",
                                  e.target.value
                                )
                              }
                              readOnly
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      {vfcs.length > 0 && (
        <button
          type="submit"
          className="btn btn-outline-primary btn-icon-text mt-3"
          onClick={handleSubmit}
        >
          <i className="mdi mdi-file-check btn-icon-prepend"></i>
          Submit
        </button>
      )}
    </div>
  );
};

export default RangeReport;
